export const setOptimizelyDpEnquiryStatus = (dpEnquiryStatus?: string | null) => {
  // eslint-disable-next-line no-underscore-dangle
  (globalThis as any).__OPTIMIZELY_WEB_DATA__ = (globalThis as any).__OPTIMIZELY_WEB_DATA__ || {};
  // eslint-disable-next-line no-underscore-dangle
  (globalThis as any).__OPTIMIZELY_WEB_DATA__.dpEnquiryStatus = dpEnquiryStatus ?? null;
};
